module.exports = __webpack_public_path__ + "static/media/standard_size.b7dacc41.svg";